'use client'

import { useAuth0 } from '@auth0/auth0-react'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useLocation } from 'react-use'

import { LoadingMessage } from '~/components/Loaders'
import routeDirectory from '~/navigation/routes'
import { useSetTenantInfo } from '~/store/slices/tenant'

export default function AuthWithToken() {
  const { origin } = useLocation()
  const { isAuthenticated, loginWithRedirect } = useAuth0()
  const setTenantInfo = useSetTenantInfo()

  const searchParams = useSearchParams()
  const token = searchParams.get('Authorization')

  // The fetched token is a JWT from DTNA that can be used with their User Claims API. We pass this
  // token to our OAuth server via the Synop-OAuth connection. Our OAuth server confirms it is valid
  // by calling the DTNA User Claims endpoint, then confirms with Auth0 before Auth0 issues a token
  // for our application.
  useEffect(() => {
    if (token) {
      const redirectToAuth0 = async () => {
        if (!isAuthenticated) {
          // Set tenant info for DTNA
          setTenantInfo({
            tenant: 'daimlertruck', // Does not actually get used
            email: '' // Email is also not needed
          })

          await loginWithRedirect({
            authorizationParams: {
              redirect_uri: origin,
              response_type: 'code',
              scope: 'openid profile email',
              connection: 'Detroit-Connect',
              // Pass the JWT to the oauth server
              login_hint: `Bearer ${token}`
            }
          })
        }
      }

      redirectToAuth0()
    } else {
      // If there is no token then the user should not have landed on this
      // page. Redirect to dashboard and thus the regular login workflow.
      window.location.replace(routeDirectory.index)
    }
  }, [isAuthenticated, loginWithRedirect, origin, token, setTenantInfo])

  return <LoadingMessage />
}
